var _path, _path2, _g, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 11C12.1193 11 11 12.1193 11 13.5V34.569C11 35.9497 12.1193 37.069 13.5 37.069H28.0517C29.4324 37.069 30.5517 35.9497 30.5517 34.569V18.6035L22.9483 11.0001H29.3175C29.3122 11 29.307 11 29.3017 11H13.5Z",
    fill: "#71D7B2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7722_35174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9482 18.6034V11L30.5517 18.6034H22.9482Z",
    fill: "#008A57"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 30.6805C23 26.704 26.2236 23.4805 30.2 23.4805C34.1764 23.4805 37.4 26.704 37.4 30.6805C37.4 34.6569 34.1764 37.8805 30.2 37.8805C26.2236 37.8805 23 34.6569 23 30.6805Z",
    fill: "#1B1C1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5385 30.343V27.9805H29.8635V30.343H27.501V31.018H29.8635V33.3805H30.5385V31.018H32.901V30.343H30.5385Z",
    fill: "#F7F7F8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7722_35174",
    x: 17.9482,
    y: 8.5,
    width: 17.6035,
    height: 17.6035,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.20694 0 0 0 0 0.51735 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7722_35174"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7722_35174",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/upload-file.d93dbf535f7c8170a6f72aaf2eca4976.svg";
export { ForwardRef as ReactComponent };